import React from 'react';
import styled from '../../../libs/styled.es.js';
import { getTrackingData } from '@teko/tracking';
import { Button } from '../../atoms/Button/Button.es.js';
import { SvgIcon } from '../../atoms/SvgIcon/SvgIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const StyledPagination = styled.ul`
  margin-top: 0;
  margin-bottom: 0;
  width: fit-content;
  display: flex;
`;
const StyledPaginationBtn = styled.li(({ theme, disabled, active }) => `
    pointer-events: ${disabled ? "none" : "auto"};
    display: inline-block;
    ${active && `color: #fff;
      border-color: ${theme.brand.primary};
      &:hover {
        color: ${theme.brand.primary};
      }`}
  `);
const PageLink = styled(Button)(({ theme, active }) => `
  min-width: 36px;
  height: 36px;
  text-align: center;
  box-shadow: none;
  border-color: #ced4da;
  color: ${theme.brand.primary};
  font-size: 12px;
  background-color: #fff;
  padding: 8px;
  margin: 5px;
  &:hover {
    background-color: #f4f4f4;
  }
  ${active && `color: #fff;
    background-color: ${theme.brand.primary};
    border-color: ${theme.brand.primary};
    border-radius: 4px;
    &:hover {
      color: ${theme.brand.primary};
      background-color: ${theme.brand.primary};
      color: #fff;
      border-color: ${theme.brand.primary};
    }
    `}
`);
const DotItem = styled.li`
  pointer-events: none;
  display: flex;
  min-width: 36px;
  height: 36px;
  color: ${(props) => props.theme.brand.primary};
  padding: 8px;
  margin: 5px;
  font-size: 12px;
  justify-content: center;
`;
const PaginationButtonWrapper = styled.div`
  z-index: 1;
  display: inline-block;
`;
const range = (from, to, step = 1) => {
  return Array.from(Array(to - from + 1).keys()).map((item) => item * step + from);
};
const Pagination = (_a) => {
  var _b = _a, {
    totalRecords = 0,
    pageLimit = 30,
    pageNeighbours = 2,
    onPageChanged,
    currentPage
  } = _b, props = __objRest(_b, [
    "totalRecords",
    "pageLimit",
    "pageNeighbours",
    "onPageChanged",
    "currentPage"
  ]);
  const totalPages = Math.ceil(totalRecords / pageLimit);
  const gotoPage = (page) => {
    onPageChanged(page);
  };
  const handleClick = (page, e) => {
    e.preventDefault();
    gotoPage(page);
  };
  const handleMoveLeft = (e) => {
    e.preventDefault();
    gotoPage(currentPage - 1);
  };
  const handleMoveRight = (e) => {
    e.preventDefault();
    gotoPage(currentPage + 1);
  };
  const fetchPageNumbers = () => {
    const totalNumbers = pageNeighbours * 2 + 3;
    const totalBlocks = totalNumbers + 2;
    if (totalPages > totalBlocks) {
      let pages2 = [];
      const curr = currentPage > totalPages ? totalPages : currentPage;
      const leftBound = curr - pageNeighbours;
      const rightBound = curr + pageNeighbours;
      const beforeLastPage = totalPages - 1;
      const startPage = leftBound > 2 ? leftBound : 2;
      const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;
      pages2 = range(startPage, endPage);
      const pagesCount = pages2.length;
      const singleSpillOffset = totalNumbers - pagesCount - 1;
      const leftSpill = startPage > 2;
      const rightSpill = endPage < beforeLastPage;
      const leftSpillPage = LEFT_PAGE;
      const rightSpillPage = RIGHT_PAGE;
      if (leftSpill && !rightSpill) {
        const extraPages = range(startPage - singleSpillOffset, startPage - 1);
        pages2 = [leftSpillPage, ...extraPages, ...pages2];
      } else if (!leftSpill && rightSpill) {
        const extraPages = range(endPage + 1, endPage + singleSpillOffset);
        pages2 = [...pages2, ...extraPages, rightSpillPage];
      } else if (leftSpill && rightSpill) {
        pages2 = [leftSpillPage, ...pages2, rightSpillPage];
      }
      return [1, ...pages2, totalPages];
    }
    return range(1, totalPages);
  };
  const pages = fetchPageNumbers();
  return pages.length > 0 ? /* @__PURE__ */ React.createElement("nav", __spreadValues({}, props), /* @__PURE__ */ React.createElement(StyledPagination, null, /* @__PURE__ */ React.createElement(PaginationButtonWrapper, __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName: "paging",
    contentName: "previousPage"
  })), /* @__PURE__ */ React.createElement(StyledPaginationBtn, {
    disabled: currentPage === 1
  }, /* @__PURE__ */ React.createElement(PageLink, {
    onClick: handleMoveLeft,
    "aria-label": "Previous page"
  }, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "chevron-back",
    size: 12
  })))), pages.map((page, index) => {
    if ([LEFT_PAGE, RIGHT_PAGE].includes(page)) {
      return /* @__PURE__ */ React.createElement(DotItem, {
        key: index
      }, "...");
    }
    return /* @__PURE__ */ React.createElement(PaginationButtonWrapper, __spreadValues({
      key: index
    }, getTrackingData({
      isTrackContent: true,
      regionName: "paging",
      contentName: "gotoPage",
      target: `${page}`
    })), /* @__PURE__ */ React.createElement(StyledPaginationBtn, {
      active: currentPage === page
    }, /* @__PURE__ */ React.createElement(PageLink, {
      onClick: (e) => handleClick(page, e),
      active: currentPage === page,
      "aria-label": "Next page"
    }, page)));
  }), /* @__PURE__ */ React.createElement(PaginationButtonWrapper, null, /* @__PURE__ */ React.createElement(StyledPaginationBtn, __spreadValues({
    disabled: currentPage === totalPages
  }, getTrackingData({
    isTrackContent: true,
    regionName: "paging",
    contentName: "nextPage"
  })), /* @__PURE__ */ React.createElement(PageLink, {
    onClick: handleMoveRight
  }, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "chevron-forward",
    size: 12
  })))))) : null;
};

export { Pagination };
